import styled from "styled-components/macro";
import { TextField } from "@mui/material";
import { DeviceType } from "../../utils/hooks/useDeviceHook";

const formFieldWidth = (deviceType: string) => {
  if (deviceType === "desktop") return "447px";
  if (deviceType === "tablet") return "421px";
  return "327px";
};

export const ResetPasswordFormGrid = styled.div`
  display: grid;
  grid-template-rows: 40px;
  grid-row-gap: 40px;
  padding-top: 12px;
  padding-bottom: 40px;
  place-items: center;
`;

export const ResetPasswordInput = styled(TextField)`
  width: 100%;
  color: ${({ theme }) => theme.greyMedium};
  background-color: #fff;
`;

export const FormFieldInput = styled.div<{
  deviceType: DeviceType;
}>`
  width: ${({ deviceType }) => formFieldWidth(deviceType)};
`;

export const ResetPasswordButtonContainer = styled.div`
  display: inline-grid;
  justify-content: flex-start;

  button {
    font-family: light !important;
  }
`;

export const ResetPasswordDesktopContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  background-color: ${({ theme }) => theme.white};
`;

export const ResetPasswordDesktopFormCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
`;

export const ResetPasswordDesktopColorBackground = styled.div`
  position: relative;
  min-height: 100vh;
  height: 100%;
  overflow: hidden;
  background-color: ${({ theme }) => theme.loginBrandPanel};
`;

export const ResetPasswordDesktopGradientLayer = styled.div`
  position: absolute;
  inset: 0;
  background: ${({ theme }) => theme.gradient};
  transform: rotate(180deg) scaleX(-1);
  transform-origin: center center;
`;

export const ResetPasswordDesktopBrandPanel = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  z-index: 1;
  padding: 0 40px 0 clamp(24px, 4vw, 55px);
  box-sizing: border-box;
  pointer-events: none;

  & img {
    pointer-events: auto;
  }
`;

export const ResetPasswordDesktopBrandRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 16px;
  width: 100%;
`;

export const ResetPasswordDesktopBrandTitleAside = styled.div`
  margin-left: auto;
  display: flex;
  align-items: flex-end;
  min-width: 0;
  padding-left: 10px;
`;

export const ResetPasswordDesktopBrandLockup = styled.img`
  display: block;
  height: 93px;
  width: auto;
  max-width: min(228px, 42vw);
  flex-shrink: 0;
`;

export const ResetPasswordDesktopBrandTitleImg = styled.img`
  display: inline-block;
  vertical-align: baseline;
  height: 12px;
  width: auto;
  max-width: min(167px, 36vw);
`;

export const ResetPasswordNonDesktopShell = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  min-height: 100dvh;
  width: 100%;
  background-color: ${({ theme }) => theme.white};
`;

export const ResetPasswordHeroBand = styled.div<{ $deviceType: DeviceType }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  gap: ${({ $deviceType }) => ($deviceType === "mobile" ? "12px" : "24px")};
  padding-left: ${({ $deviceType }) =>
    $deviceType === "mobile" ? "16px" : "24px"};
  padding-right: ${({ $deviceType }) =>
    $deviceType === "mobile" ? "16px" : "24px"};
  padding-bottom: ${({ $deviceType }) =>
    $deviceType === "mobile" ? "12px" : "24px"};
  padding-top: ${({ $deviceType }) =>
    $deviceType === "mobile"
      ? "calc(32px + env(safe-area-inset-top, 0px))"
      : "calc(40px + env(safe-area-inset-top, 0px))"};
  background: ${({ theme, $deviceType }) =>
    $deviceType === "mobile"
      ? theme.loginHeroGradientMobile
      : theme.loginHeroGradient};
`;

export const ResetPasswordHeroLockupImg = styled.img<{
  $deviceType: DeviceType;
}>`
  display: block;
  height: ${({ $deviceType }) => ($deviceType === "mobile" ? "28px" : "40px")};
  width: auto;
  max-width: 100%;
`;

export const ResetPasswordHeroTitleImg = styled.img<{
  $deviceType: DeviceType;
}>`
  display: block;
  height: ${({ $deviceType }) => ($deviceType === "mobile" ? "11px" : "13px")};
  width: auto;
  max-width: min(200px, 72vw);
`;

export const ResetPasswordNonDesktopContents = styled.div<{
  $deviceType: DeviceType;
}>`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  padding-top: ${({ $deviceType }) =>
    $deviceType === "mobile" ? "32px" : "80px"};
  padding-left: ${({ $deviceType }) =>
    $deviceType === "tablet" ? "clamp(24px, 12vw, 96px)" : "16px"};
  padding-right: ${({ $deviceType }) =>
    $deviceType === "tablet" ? "clamp(24px, 12vw, 96px)" : "16px"};
  padding-bottom: calc(48px + env(safe-area-inset-bottom, 0px));
`;

export const Spinner = styled.div`
  text-align: center;
  margin-top: 40%;
`;

export const ResetPasswordCenterContainerPaddedTop = styled.div`
  max-width: 480px;
  width: 100%;
  display: grid;
  align-content: center;
  margin: auto;
  place-items: center;
  padding: 10px;
  box-sizing: border-box;
  text-align: center;
`;
